import React, { useState, useEffect } from "react";
import "./Medicalwear.css";

// Images
import emergencyroom from "../../images/emergencyroom.jpeg";
import surgeonbusyday from "../../images/ordinary-busy-day-surgeon.jpg";
import productspacking from "../../images/pdpimage/medicalwearfour.jpg";
import disposablesurgicalgowns from "../../images/pdpimage/medicalwearone.jpg";
import madeInIndiaImg from "../../images/madeinindia.png";
import stitching from "../../images/pdpimage/medicalweartwo.jpg";
import fabric from "../../images/pdpimage/medicalwearthird.jpg";
import surgicalgownbanner from "../../images/medical-wear-banner.jpg";

const whatsappNumber = "+919619065205";

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need Custom Packaging or Hospital-Wide Procurement?</h3>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const MedicalWear = () => {
  useEffect(() => {
    document.title = "Built by Us, Trusted by Surgeons";
  }, []);

  const galleryImages = [disposablesurgicalgowns, fabric, stitching, productspacking];
  const [mainImage, setMainImage] = useState(disposablesurgicalgowns);

  const featureList = [
    { icon: "🛡️", text: "Level 3 Protection (AAMI PB70 compliant)" },
    { icon: "🌬️", text: "Breathable & Lightweight (Non-woven SMS fabric)" },
    { icon: "🩺", text: "Full-Sleeve Design (Elastic cuffs, reinforced seams)" },
    {
      icon: <img src={madeInIndiaImg} alt="Made in India" style={{ height: "71px" }} />,
      text: "Made in India (MDR 2017/745 certified)",
    },
  ];

  const variants = [
    {
      title: "Premium Surgical Gown",
      img: require("../../images/premium-surgical-gown.jpg"),
      features: [
        "3-layer SMS fabric",
        "Level 3 fluid resistance",
        "Standard fit for general surgery",
      ],
    },
    {
      title: "Reinforced Surgical Gown",
      img: require("../../images/reinforced-surgical-gown.jpg"),
      features: [
        "Extra reinforcement on chest/arms",
        "Level 4 fluid resistance",
        "For heavy-duty procedures",
        "Reusable ties",
      ],
    },
    {
      title: "Wraparound Surgical Gown",
      img: require("../../images/wrap-around-surgical-gown.jpg"),
      features: [
        "360° coverage design",
        "Level 3 fluid resistance",
        "Easy tie-back closure",
        "Ideal for high-movement procedures",
      ],
    },
    {
      title: "Wraparound Reinforced Gown",
      img: require("../../images/wraparound-reinforced-surgical-gown.jpg"),
      features: [
        "Combines wraparound + reinforced panels",
        "Level 4 fluid resistance",
        "For high-exposure surgeries",
        "Double-layer critical zones",
      ],
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <section
        className="homepage-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${surgicalgownbanner})`,
        }}
      >
        <h1 className="homepage-hero-title">Disposable Surgical Gown</h1>
        <p className="homepage-hero-subtext">
          Advanced barrier protection for high-risk clinical environments
        </p>
        <div className="homepage-hero-buttons">
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Bulk Quote
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
            className="homepage-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request Brochure
          </a>
        </div>
      </section>

      {/* Features Strip */}
      <section className="mw-features-strip">
        <div className="mw-container mw-features">
          {featureList.map((item, i) => (
            <div className="mw-feature-item" key={i}>
              <span>{item.icon}</span>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery Without Magnifier */}
      <section className="mw-product-details mw-container gown-details" id="gowndetailing">
        <div className="mw-gallery">
          <div className="mw-gallery-main">
            <img
              src={mainImage}
              alt="Surgical Gown"
              className="mw-gallery-main-img"
            />
          </div>
          <div className="mw-gallery-thumbs">
            {galleryImages.map((img, index) => (
              <div
                key={index}
                className={`gallery-thumb-img-box ${
                  mainImage === img ? "active-thumb" : ""
                }`}
                onClick={() => setMainImage(img)}
              >
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="mw-product-info">
          <h2 className="homepage-section-title">Product Description</h2>
          <p>
            Our disposable surgical gowns are engineered for{" "}
            <strong>infection control</strong> in operating rooms and ICUs.
            Designed with fluid-resistant SMS material, they provide{" "}
            <strong>&gt; 90% bacterial filtration efficiency (BFE)</strong>{" "}
            while ensuring clinician comfort during prolonged procedures. Ideal
            for <strong>orthopedic, general surgery, and emergency care</strong>.
          </p>

          <h2 className="homepage-section-title">Specifications</h2>
          <table className="mw-specs-table">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Material</td>
                <td>3-layer SMS (Spunbond-Meltblown-Spunbond)</td>
              </tr>
              <tr>
                <td>Sterility</td>
                <td>Non-sterile (Sterile options available)</td>
              </tr>
              <tr>
                <td>Sizes</td>
                <td>S, M, L, XL</td>
              </tr>
              <tr>
                <td>Packaging</td>
                <td>50 pcs/carton</td>
              </tr>
              <tr>
                <td>Standards</td>
                <td>ISO 13485, AAMI PB70 Level 3</td>
              </tr>
            </tbody>
          </table>

          <div className="mw-product-cta">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
              className="homepage-btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Request For Quote
            </a>

            <a
              href={`tel:+919619065205`}
              className="homepage-btn-primary mw-btn-outline"
            >
              Call for Samples
            </a>
          </div>
        </div>
      </section>

      {/* Product Variants */}
      <section className="mw-product-variants mw-container" id="products">
        <h2 className="homepage-section-title">Choose Your Surgical Gown Type</h2>
        <div className="mw-variant-grid">
          {variants.map((variant, idx) => (
            <div key={idx} className="mw-variant-card">
              <img src={variant.img} alt={variant.title} />
              <h3>{variant.title}</h3>
              <ul>
                {variant.features.map((f, i) => (
                  <li key={i}>{f}</li>
                ))}
              </ul>
              <a href="#gowndetailing" className="btn btn-outline">
                View Details
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* Use Cases */}
      <section className="mw-use-cases mw-container">
        <h2 className="homepage-section-title" style={{ textAlign: "center" }}>
          Where It’s Used
        </h2>
        {[{ title: "Operating Theatres", text: "Preferred by surgeons for major procedures due to high fluid resistance. The reinforced seams and long sleeves provide maximum protection during critical surgeries like orthopedics and cardiovascular operations.", img: surgeonbusyday }, { title: "Emergency Rooms", text: "Rapid donning/doffing design for critical care scenarios. The breathable fabric ensures comfort during high-stress emergency procedures while maintaining >90% BFE against bloodborne pathogens.", img: emergencyroom }].map((use, i) => (
          <div className="mw-use-case" key={i}>
            <div className="mw-use-case-img">
              <img src={use.img} alt={use.title} />
            </div>
            <div className="mw-use-case-text">
              <h3>{use.title}</h3>
              <p>{use.text}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Compliance */}
      <section className="mw-compliance">
        <h2 className="homepage-section-title">Compliance & Certifications</h2>
        <ul className="mw-cert-list">
          <li><span className="checkmark">✅</span><span>MDR Compliant</span></li>
          <li><span className="checkmark">✅</span><span>ISO 13485</span></li>
          <li><span className="checkmark">✅</span><span>AAMI PB70</span></li>
        </ul>
        <p>
          <em>
            "Our gowns meet stringent quality benchmarks for disposable medical
            wear, with batch-wise quality validation."
          </em>
        </p>
      </section>

      {/* Comparison */}
      <section className="mw-comparison mw-container">
        <h2 className="homepage-section-title" style={{ textAlign: "center" }}>
          Why Choose Sabiote?
        </h2>
        <table className="mw-comparison-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Sabiote</th>
              <th>Generic Brands</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Fabric Quality</td>
              <td>3-layer SMS (Spunbond-Meltblown-Spunbond)</td>
              <td>2-layer Polypropylene</td>
            </tr>
            <tr>
              <td>Fluid Resistance</td>
              <td>&gt; 90% (AAMI PB70 Level 3/4)</td>
              <td>60-70% (Level 2)</td>
            </tr>
            <tr>
              <td>Critical Zone Reinforcement</td>
              <td>Double-layer stitching</td>
              <td>Single-layer</td>
            </tr>
          </tbody>
        </table>
      </section>

      <ContactBanner />
    </>
  );
};

export default MedicalWear;
